import history from "history/browser";
import {AuthenticationState} from "../state/AuthenticationState";

export const logout = () => {
    AuthenticationState.logout();

    const location = history.location;
    history.push('/login', {redirectTo: location.pathname + location.search + location.hash});
}